/* @ngInject */
function CampaignChecklistController ($sce, $rootScope, $scope, $q, $state, $translate, $location, $timeout, CampaignService, SliderService, ToastService, UdsModalService, ModalService, AuditService, BriefingService) {
  const getBindCampaignDialogController = () => $q.when(import('../../../core/dialogs/bind-campaign/bind-campaign-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))

  $scope.briefings = []
  $scope.totalCount = 0
  $scope.companyFeatures = {
    maxBriefings: {
      maxReached: false,
      data: {},
      tooltip: ''
    },
    notHasAdvancedDashboardsAccess: false
  }

  const api = {
    getBindCampaignDialogController,
    getUpgradeCompanyPlanDialogController,
    _bindChecklistToCampaign,
    _unbindChecklistFromCampaign,
    _formatDate,
    _openUpgradeCompanyPlanDialog
  }

  this.getApi = () => api

  activate()

  function activate () {
    CampaignService.getCampaignChecklists($scope.campaign.id)
      .then(briefings => {
        $scope.briefings = briefings
        $scope.totalCount = $scope.briefings.length

        $scope.briefings.map(briefing => {
          const briefingDate = new Date(briefing.createdAt)
          briefing.date = api._formatDate(briefingDate)
          briefing.description = $sce.trustAsHtml(briefing.description.replace(/<\/?div>/g, ''))
        })
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  $scope.emptyState = {
    imgPath: 'campaign-checklist',
    title: $translate.instant('campaignEdit.checklists.emptyState.title'),
    message: $translate.instant('campaignEdit.checklists.emptyState.message'),
    button: {
      icon: 'plus',
      type: 'primary',
      text: $translate.instant('add'),
      click: () => $scope.createNewBriefing(),
      disabled: $scope.campaign.status === 'FINISHED',
      tooltip: {
        text: $translate.instant('campaignErrors.campaignFinished'),
        position: 'bottom',
        disabled: $scope.campaign.status !== 'FINISHED'
      }
    }
  }

  const deregisterSelectChecklistFloatingToolBar = $rootScope.$on('campaign.select-checklist-floating-tool-bar', function (event, info) {
    $scope.selectedChecklist = info?.checklist
    $scope.action = info?.action
  })

  $scope.$on('$destroy', () => {
    deregisterSelectChecklistFloatingToolBar()
  })

  $scope.handleEditButton = id => {
    $timeout(() => {
      $state.go('admin.auditBriefing', {
        id: id,
        type: 'AUDIT',
        campaignId: $scope.campaign.id,
        origin: 'CAMPAIGNS',
        activeTab: 'tab-6'
      })
    }, 100)
  }

  $scope.createNewBriefing = () => {
    if ($scope.campaign.status === 'FINISHED') return

    $state.go('admin.auditBriefingNew', {
      type: 'AUDIT',
      campaignId: $scope.campaign.id,
      origin: 'CAMPAIGNS',
      activeTab: 'tab-6'
    })
  }

  $scope.openBindCampaignDialog = (postId) => {
    getBindCampaignDialogController().then(({ BindCampaignDialogController }) => {
      const bindCampaignDialog = UdsModalService.createModal({
        controller: BindCampaignDialogController,
        modalName: 'bindCampaignDialog',
        data: {
          currentModule: 'requests',
          assetId: postId,
          campaignId: $scope.campaign.id,
          campaignName: $scope.campaign.title
        },
        onClose: (bindDetails) => {
          if (bindDetails) {
            if (bindDetails.selectedCampaign) {
              api._bindChecklistToCampaign(bindDetails)
            } else {
              api._unbindChecklistFromCampaign(bindDetails)
            }
          }
        }
      })
      bindCampaignDialog.open()
    })
  }

  $scope.selectChecklist = (briefing) => {
    if (briefing.isArchived) return

    if ($scope.selectedChecklist?.id === briefing.id) {
      $scope.selectedChecklist = null
    } else {
      $scope.selectedChecklist = briefing
    }
  }

  function _bindChecklistToCampaign (bindDetails) {
    AuditService.bindAuditBriefingToCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        activate()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _unbindChecklistFromCampaign (bindDetails) {
    BriefingService.unbindBriefingFromCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        $scope.$emit('campaign.reload-actions')
        activate()
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _formatDate (date) {
    const dayFormatter = new Intl.DateTimeFormat('pt-BR', { day: '2-digit' })
    const monthFormatter = new Intl.DateTimeFormat('pt-BR', { month: '2-digit' })
    const yearFormatter = new Intl.DateTimeFormat('pt-BR', { year: 'numeric' })

    return `${dayFormatter.format(date)}/${monthFormatter.format(date)}/${yearFormatter.format(date)}`
  }

  function _openUpgradeCompanyPlanDialog (pricingData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: pricingData
      })
      upgradeCompanyPlanDialog.open()
    })
  }
}

export { CampaignChecklistController }
